import { css } from 'emotion';
import { getInterUIDynamicMetricCssObject } from 'fonts/Inter-UI/metrics';

export namespace styles {
  export const container = css({
    flex: 0,
    flexGrow: 1,
    padding: '16px 24px 16px 0',
    borderBottom: '1px solid #EBEBEB',
    backgroundColor: 'white'
  });

  export const svgContainer = css({
    marginRight: 15
  });

  export const label = css({
    color: '#888888',
    ...getInterUIDynamicMetricCssObject(14),
    display: 'flex',
    alignItems: 'center',
    ' span': {
      marginRight: 16
    },
    '<': {
      cursor: 'not-allowed'
    }
  });
}
